"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grantConsentArgsValidator = exports.denyConsentArgsValidator = exports.getConsentDataArgsValidator = void 0;
var suretype_1 = require("suretype");
// --------------------------
// 1) Get consent data
// --------------------------
var getConsentDataArgsSchema = suretype_1.v.object({
    consent_challenge: suretype_1.v.string().required()
});
exports.getConsentDataArgsValidator = (0, suretype_1.compile)(getConsentDataArgsSchema);
// --------------------------
// 2) Case A: Deny consent
// --------------------------
var denyConsentArgsSchema = suretype_1.v.object({
    consent_challenge: suretype_1.v.string().required(),
});
exports.denyConsentArgsValidator = (0, suretype_1.compile)(denyConsentArgsSchema);
// --------------------------
// 2) Case B: Grant consent
// --------------------------
var grantConsentArgsSchema = suretype_1.v.object({
    consent_challenge: suretype_1.v.string().required(),
    grant_scope: suretype_1.v.array(suretype_1.v.string()).required()
});
exports.grantConsentArgsValidator = (0, suretype_1.compile)(grantConsentArgsSchema);
